/*import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
//import timeGridPlugin from '@fullcalendar/timegrid';
//import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import itLocale from '@fullcalendar/core/locales/it';
import enLocale from '@fullcalendar/core/locales/en-gb';*/

import Mustache from 'mustache';

const INIT_OPTIONS = {
    locale: 'it',
    onClickDay: null,
    onClickTime: null,
    onDragStart: null,
    onDragEnd: null,
    onDrop: null,
    data: [],
    colLeftTitle: '',
    colRightTitle: '',
}

const OPT_FIELDS = {
    isDisabled: false,
    isSelected: false,
    times: [],
    selectedTime: 0
}

const TEMPLATE_EVENT = `
    {{#groupTag}}<span class="ab-group-tag" {{#groupColor}}style="background-color:{{groupColor}}"{{/groupColor}}>{{groupTag}}</span>{{/groupTag}}
    <span class="ab-event-time">{{time}}</span>
    -
    <span class="ab-event-title">{{title}}</span>
`;
const TEMPLATE_FILTER = `
    <div class="ab-filter">
        <button>{{resetDescription}}</button>
        <select>
            {{#options}}
                <option value="{{value}}">{{description}}</option>
            {{/options}}
        </select>
    </div>
`;
const TEMPLATE = `
    <div class="ab-calendar-wrapper"></div>
    <div class="ab-calendar-loader">
		<div class="spinner-border text-primary" role="status">
			<span class="sr-only">Loading...</span>
		</div>
	</div>
`;

const CSS_DISABLED = 'fc-day-disabled';
const CSS_SELECTED = 'ab-day-selected';
const CSS_LOADER_SHOW = 'show';

const SELECTOR_CAL = '.fc';
const SELECTOR_CAL_TITLE = SELECTOR_CAL + ' .fc-toolbar-chunk .fc-toolbar-title';
const SELECTOR_CAL_FILTER = SELECTOR_CAL + ' .fc-toolbar-chunk .ab-filter';
const SELECTOR_WRAPPER = '.ab-calendar-wrapper';
const SELECTOR_LOADER = '.ab-calendar-loader';

class ABCalendarCore {
    target;
    calendar;
    options;
    today;
    firstAvailDate;
    currDate;

    events;
    noFetch;
    currentFilter;
    constructor(target, options) {
        this.target = this.getTarget(target);
        this.options = this.getOptions(options);
        this.renderTemplate();
        this.calendar = this.initCalendar();
    }

    getOptions(options) {
        const newOpt =  Object.assign({}, INIT_OPTIONS, options);
        if (newOpt.data.length > 0) {
            newOpt.data.forEach((el) => {
                Object.keys(OPT_FIELDS).forEach(optKey => {
                    if (typeof el[optKey] === 'undefined') {
                        el[optKey] = OPT_FIELDS[optKey];
                    }
                });
                el.dateObj = new Date(el.date + (
                    el.times.length > 0 ? ' ' + el.times[el.selectedTime] : ''
                ));
            });
        }
        return newOpt;
    }
    getTarget(target) {
        return document.querySelector(target);
    }

    initCalendar() {
        return new FullCalendar.Calendar(this.target.querySelector(SELECTOR_WRAPPER), {
            //plugins: [dayGridPlugin, /*timeGridPlugin, listPlugin,*/ interactionPlugin],
            locale: this.options.locale || 'it',
            initialView: 'dayGridMonth',
            headerToolbar: {
                left: 'today prev,next',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay,list'
            },
            editable: true,
            selectable: true,
            //disableDragging: true,

            eventContent: ({event, element, view}) => this.renderEvent(event, element, view),
            events: this.getEvents(),
            eventClick: this.eventClick,

            eventDragStart: (info) => {
                if (typeof this.options.onDragStart === 'function') {
                    this.options.onDragStart(info);
                }
            },
            eventDragStop: (info) => {
                if (typeof this.options.onDragEnd === 'function') {
                    this.options.onDragEnd(info);
                }
            },
            eventDrop: (info) => {
                if (typeof this.options.onDrop === 'function') {
                    this.options.onDrop(info);
                }
            },
        });
    }

    render() {
        this.calendar.render();
    }

    renderTemplate() {
        var html = Mustache.render(TEMPLATE);
        this.target.insertAdjacentHTML('beforeend', html);
    }    

    getEvents() {
        if (typeof this.options.events === 'function') {            
            return (info, successCallback, failureCallback) => {
                //console.log('--- events',{info, successCallback, failureCallback});

                if (this.noFetch) {
                    this.noFetch = false;
                    successCallback(this.filterEvents(this.events));                    
                } else {
                    this.loadStart();
                    this.options.events(
                        info,
                        (response) => {
                            this.events = response;
                            successCallback(this.filterEvents(response));
                            this.loadEnd();
                        },
                        (errorMsg) => {
                            failureCallback(errorMsg);
                            this.loadEnd();
                        }
                    );
                }
            }
        }
        return this.options.events;
    }
    filterEvents(events) {
        if (this.currentFilter && events) {
            //console.log('---filterEvents', { filterId: this.currentFilter });
            return events.filter( el => el.extendedProps && el.extendedProps.groupId && el.extendedProps.groupTag === this.currentFilter);
        }
        return events;
    }

    setFilter(filterId) {
        //console.log('---', {filterId});
        this.currentFilter = filterId;
        this.noFetch = true;
        this.calendar.refetchEvents();
    }

    getGroup(groupId) {
        return this.options.filter.data.find(el => el.id == groupId);
    }

    renderEvent(event, element, view) {
        //console.log('--eventContent', { event, element, view });
        let wrapper = document.createElement('span');

        wrapper.classList.add('ab-event-custom');
        if (event.extendedProps && event.extendedProps.isCancel) {
            wrapper.classList.add('ab-event-status-cancel');
        }

        /*let groupData = null;
        if (event.extendedProps && event.extendedProps.groupId) {
            groupData = this.getGroup(event.extendedProps.groupId);
        }
        console.log('--eventContent', { groupData });*/

        wrapper.innerHTML = Mustache.render(TEMPLATE_EVENT, {
            //groupTag: groupData && groupData.id,
            //groupColor: groupData && groupData.color,
            groupTag: event.extendedProps && event.extendedProps.groupTag,
            groupColor: event.extendedProps && event.extendedProps.groupColor,
            time: ("0" + event.start.getHours()).slice(-2) + ':' + ("0" + event.start.getMinutes()).slice(-2),
            title: event.title
        });

        let arrayOfDomNodes = [ wrapper ]
        return { domNodes: arrayOfDomNodes }
    }

    renderFilters() {
        if (this.options.filter) {
            const selectOpt = [{value: '', description: this.options.filter.labels.default}].concat(this.options.filter.data.map(el => ({value: el.id, description: el.description})));
            const rendered = Mustache.render(TEMPLATE_FILTER, {
                options: selectOpt,
                resetDescription:  this.options.filter.labels.reset
            });

            this.target.querySelector(SELECTOR_CAL_TITLE).insertAdjacentHTML('afterend',rendered);
            this.bindEventsFilter();
        }
    }
    bindEventsFilter() {
        this.target.querySelector(SELECTOR_CAL_FILTER).addEventListener('change', (evt) => this.setFilter(evt.target.value));
    }

    addEvent(eventData, moveToEvent) {
        //console.log('---addEvent', { eventData });
        //this.calendar.addEventSource(eventData);
        if (this.events) {
            this.events.push(eventData);
        } else {
            this.events = [].push(eventData);
        }
        this.noFetch = true;
        this.calendar.refetchEvents();

        if (moveToEvent) {
            this.calendar.gotoDate(eventData.start);
        }
    }
    eventClick = (eventClickInfo) => {
        if (typeof this.options.eventClick === 'function') {
            this.options.eventClick(eventClickInfo);
        }
    }

    refetchEvents() {
        return this.calendar.refetchEvents();
    }

    loadStart() {
        var loader = this.target.querySelector(SELECTOR_LOADER);
        loader.classList.add(CSS_LOADER_SHOW);
    }
    loadEnd() {
        var loader = this.target.querySelector(SELECTOR_LOADER);
        loader.classList.remove(CSS_LOADER_SHOW);
    }    
}

class ABCalendar {
    calendarCore;
    constructor(target, options) {
        this.calendarCore = new ABCalendarCore(target, options);
    }

    render() {
        this.calendarCore.render();
    }

    getSelectedDay() {
        this.calendarCore.getDayDataSelected();
    }

    refetchEvents() {
        this.calendarCore.refetchEvents();
    }

    setFilter(filterId) {
        this.calendarCore.setFilter(filterId);
    }
    clearFilter() {
        this.calendarCore.setFilter(null);
    }

    addEvent(eventData, moveToEvent = true) {
        this.calendarCore.addEvent(eventData, moveToEvent);
    }
}

window.ABCalendar = ABCalendar;

export default ABCalendar;